import Vue from 'vue'
import router from './router'
import App from './App.vue'
import api from './service/Webservice'
import VeeValidate from 'vee-validate'
import shareService from './service/ShareService'
import loaderService from './service/LoaderService'
import 'vuejs-noty/dist/vuejs-noty.css'
import VueAxios from 'vue-axios'
import VueNoty from 'vuejs-noty'
import axios from 'axios';
import moment from "moment";
import VueAuthenticate from 'vue-authenticate'
export const bus = new Vue();
import Vue2Filters from 'vue2-filters'
import VueSocialSharing from 'vue-social-sharing'
var AddToCalendar = require('vue-add-to-calendar');
import { Datetime } from 'vue-datetime'
import Echo from "laravel-echo";
window.Pusher = require('pusher-js');
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

Vue.component('datetime', Datetime);

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: "local",
  wsHost:"api.oz.zone",
  wssPort:6001,
  disableStats: true
});
Vue.use(AddToCalendar);
Vue.use(VueSocialSharing);

Vue.use(Vue2Filters)
Vue.use(VueNoty, {
  timeout: 1500
})
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: 'https://candidate.oz.zone', // Your API domain
  providers: {
    linkedin: {
      name: 'linkedin',
      url: '',
      authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
      redirectUri: 'https://candidate.oz.zone/home',
      requiredUrlParams: ['state', 'scope'],
      scope: ['r_emailaddress', 'r_liteprofile'],
      scopeDelimiter: ' ',
      state: 'STATE',
      oauthType: '2.0',
      popupOptions: { width: 527, height: 582 },
      clientId: "789f6djc0edcj2",
      tokenPath: 'code',
      responseType: 'code'
    }
  }
})
Vue.$loaderService = loaderService
Vue.$api = api
Vue.$shareService = shareService

Object.defineProperty(Vue.prototype, '$api', {
  get() {
    return api
  }
})


Object.defineProperty(Vue.prototype, '$shareService', {
  get() {
    return shareService
  }
})

Object.defineProperty(Vue.prototype, '$loaderService', {
  get() {
    return loaderService
  }
})

Vue.config.productionTip = false
Vue.use(VeeValidate, {
  classes: true,
  inject: 'false'
})

Vue.use(require('vue-moment'))

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.filter('titleCase', function (value) {
  if (!value) {
    return ''
  } else {
    var str = ''
    var arr = value.split('_')
    for (var i = 0; i < arr.length; i++) {
      if (i == 0) {
        str = arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
      } else {
        str = ' ' + arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
      }
    }
    return str
  }
})
Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.filter('dateTimeFilter', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    // var localDate = moment(testDateUtc).local();

    return testDateUtc.format('DD/MM/YYYY, hh:mm A')
  }
});


Vue.filter('dateTimeFilter2', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    var localDate = moment(testDateUtc).local();

    return localDate.format('DD/MM/YYYY, hh:mm A')
  }
});


Vue.filter('date1', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    // var localDate = moment(testDateUtc).local();

    return testDateUtc.format('DD-MM-YYYY hh:mm A')
  }
});
Vue.filter('time1', function (value) {
  if (value) {
    var testDateUtc = moment(value);
    var localDate = moment(testDateUtc).local();
    var localDate2 = moment().local();
    var dif = localDate2.diff(localDate, 'days');
    if (dif == 0) {
      return testDateUtc.format('hh:mm A');
    } else {
      return testDateUtc.format('DD/MM/YYYY');
    }
  }
});

Vue.filter('timeFilter', function (value) {
  var abc = "05-05-2021 " + value;

  console.log(abc);
  if (abc) {
    var testDateUtc = moment.utc(abc);
    var localDate = moment(testDateUtc).local();

    return localDate.format('hh:mm A')
  }
});


Vue.filter('dateFilter', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    // var localDate = moment(testDateUtc).local();
    return testDateUtc.format('DD-MM-YYYY')
  }
});

Vue.filter('dateFilter3', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    // var localDate = moment(testDateUtc).local();
    return testDateUtc.format('DD MMM YYYY')
  }
});


Vue.filter('dateFilter2', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    var localDate = moment(testDateUtc).local();

    var dif = Math.floor(((Date.now() - localDate) / 1000) / 86400);
    if (dif < 30) {
      var date = new Date(localDate),
        diff = (((new Date()).getTime() - date.getTime()) / 1000),
        daydiff = Math.floor(diff / 86400);

      if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31)
        return '';

      if (daydiff == 0) {
        return 'today';
      } else if (daydiff < 0) {
        return 'overdue'

      } else {
        return 'due date ' +
          localDate.format('DD MMM YYYY')

      }

    } else {
      return 'overdue'
    }
  }
});


Vue.filter('dateFilter1', function (value) {
  if (value) {
    var testDateUtc = moment.utc(value);
    var localDate = moment(testDateUtc).local();

    var dif = Math.floor(((Date.now() - localDate) / 1000) / 86400);

    if (dif < 30) {
      var date = new Date(localDate),
        diff = (((new Date()).getTime() - date.getTime()) / 1000),
        daydiff = Math.floor(diff / 86400);

      if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31)
        return '';

      return daydiff == 0 && (
        diff < 60 && "Just now" ||
        diff < 120 && "1 minute ago" ||
        diff < 3600 && Math.floor(diff / 60) + " minutes ago" ||
        diff < 7200 && "1 hour ago" ||
        diff < 86400 && Math.floor(diff / 3600) + " hours ago") ||
        daydiff == 1 && "Yesterday" ||
        daydiff < 7 && daydiff + " days ago" ||
        daydiff < 31 && Math.ceil(daydiff / 7) + " weeks ago";
    } else {
      // var datePipe = new DatePipe("en-US");
      // value = datePipe.transform(value, 'MMM-dd-yyyy');
      // return value;
      return localDate.format('DD MMM YYYY')
    }

    return localDate.format('DD MMM YYYY | hh:mm A')
  }
});



// WEBPACK FOOTER //
// ./src/main.js